import { useCallback, useMemo } from 'react';
import { useLocation, useHistory } from 'react-router-dom';
import queryString from 'query-string';

// A custom hook that builds on useLocation to parse
// the query string for you.
function useQuery() {
  const history = useHistory();
  const {
    search,
    pathname
  } = useLocation();
  const query = useMemo(() => queryString.parse(search), [search]);
  const createQueryString = useCallback(params => queryString.stringify(params), []);
  const updateQuery = useCallback(updatedQuery => {
    let pathObj = {
      pathname,
      search: createQueryString(updatedQuery)
    };
    history.push(pathObj);
  }, [createQueryString, history, pathname]);
  return {
    query,
    search,
    pathname,
    createQueryString,
    updateQuery,
    history
  };
}
export default useQuery;